<template>
  <div
    v-if="!valueInner.automatico"
    class="mb-1 mt-50 corner"
  >
    <b-row
      align-h="between"
      :style="[{'margin-bottom: -0.8rem;': valueInner.complementoRegra !== ''}]"
    >
      <b-col cols="10">
        <div style="display: flex;align-items: baseline;">
          <div class="circle">
            {{ grupo }}
          </div>
          <div>
            <span>{{ valueInner.descricao }}</span>
            <span
              v-if="valueInner.obrigatorioRegra"
              style="color: red;margin-left: 0.3rem;"
            >* </span>
          </div>
        </div>
      </b-col>
      <b-col cols="auto">
        <anexo-item-check-list
          v-if="valueInner.tipoRegra !== 'tags'"
          :existe-anexo="valueInner.nomeArquivo && valueInner.nomeArquivo != ''"
          :gerado-proposta="geradoProposta"
          :proposta-id="propostaId"
          :item-id="valueInner.id > 0 ? valueInner.id.toString() : valueInner.code"
          :nome-arquivo="valueInner.nomeArquivo"
          :externo="true"
          :desabilitar="desabilitar"
          @add-file="adicionarArquivoItem($event)"
          @remover-arquivo="removerArquivoItem"
        />
      </b-col>
    </b-row>
    <b-row class="mb-50">
      <b-col cols="12">
        <span style="font-size: 11px;">{{ valueInner.complementoRegra }}</span>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        v-if="valueInner.tipoRegra === 'numerico'"
        cols="4"
      >
        <validation-provider
          #default="{ errors }"
          :rules="valueInner.obrigatorioRegra ? 'required' : ''"
          name="Preenchimento obrigatório"
          :vid="valueInner.id > 0 ? valueInner.id.toString() : getCode"
        >
          <b-input
            v-model="valueInner.resposta"
            type="number"
            min="0"
            placeholder="Responda aqui"
            :class="[{'campo-desabilitado': desabilitar}]"
            :disabled="desabilitar"
            @keypress="isNumberValid($event)"
          />
          <small class="text-danger">{{ mostrarErro(errors[0]) }}</small>
        </validation-provider>
      </b-col>
      <b-col v-else-if="valueInner.tipoRegra === 'textolivre'">
        <validation-provider
          #default="{ errors }"
          :rules="valueInner.obrigatorioRegra ? 'required' : ''"
          name="Preenchimento obrigatório"
          :vid="valueInner.id > 0 ? valueInner.id.toString() : getCode"
        >
          <b-textarea
            v-model="valueInner.resposta"
            placeholder="Responda aqui"
            :class="[{'campo-desabilitado': desabilitar}]"
            :disabled="desabilitar"
          />
          <small class="text-danger">{{ mostrarErro(errors[0]) }}</small>
        </validation-provider>
      </b-col>
      <b-col v-else-if="valueInner.tipoRegra === 'caixaselecao'">
        <b-form-group>
          <validation-provider
            #default="{ errors }"
            :rules="valueInner.obrigatorioRegra ? 'required' : ''"
            name="Preenchimento obrigatório"
            :vid="valueInner.id > 0 ? valueInner.id.toString() : getCode"
          >
            <b-form-checkbox-group
              v-model="valueInner.listaRespostas"
              :options="valueInner.servicosItems"
              value-field="descricao"
              text-field="descricao"
              :disabled="desabilitar"
              stacked
              @input="selecionadoOutrosCaixaSelecao($event)"
            />
            <small class="text-danger">{{ mostrarErro(errors[0]) }}</small>
          </validation-provider>
        </b-form-group>
        <validation-provider
          v-if="(valueInner.tipoRegra === 'caixaselecao') && (valueInner.outrosSelecionado)"
          #default="{ errors }"
          :rules="(valueInner.outrosSelecionado)? 'required' : ''"
          :vid="getCode"
        >
          <b-input
            v-model="valueInner.complementoOutros"
            :placeholder="'Complemento'"
            :disabled="desabilitar"
            class="mt-50"
          />
          <small
            v-if="errors[0]"
            class="text-danger"
          >Campo obrigatório</small>
        </validation-provider>
      </b-col>
      <b-col v-else-if="valueInner.tipoRegra === 'listasuspensa'">
        <validation-provider
          #default="{ errors }"
          :rules="valueInner.obrigatorioRegra ? 'required' : ''"
          name="Preenchimento obrigatório"
          :vid="valueInner.id > 0 ? valueInner.id.toString() : getCode"
        >
          <v-select
            v-model="valueInner.resposta"
            :options="optionsDescricao(valueInner)"
            :placeholder="'Selecione a resposta'"
            :clearable="false"
            :disabled="desabilitar"
            @input="selecionadoOutros($event, valueInner)"
          />
          <small class="text-danger">{{ mostrarErro(errors[0]) }}</small>
        </validation-provider>
        <validation-provider
          v-if="(valueInner.tipoRegra === 'listasuspensa') && (valueInner.outrosSelecionado)"
          #default="{ errors }"
          :rules="(valueInner.outrosSelecionado)? 'required' : ''"
          :vid="getCode"
        >
          <b-input
            v-model="valueInner.complementoOutros"
            :placeholder="'Complemento'"
            :disabled="desabilitar"
            class="mt-50"
          />
          <small
            v-if="errors[0]"
            class="text-danger"
          >Campo obrigatório</small>
        </validation-provider>
      </b-col>
      <b-col v-else-if="valueInner.tipoRegra === 'tags'">
        <validation-provider
          #default="{ errors }"
          :rules="valueInner.obrigatorioRegra ? 'required' : ''"
          name="Preenchimento obrigatório"
          :vid="valueInner.id > 0 ? valueInner.id.toString() : getCode"
        >
          <multi-cnpj-input
            ref="multiCnpjInput"
            v-model="valueInner.listaRespostas"
            input-style="width: 30%;"
            :disabled="desabilitar"
            :externo="true"
          />
          <small class="text-danger">{{ mostrarErro(errors[0]) }}</small>
        </validation-provider>
      </b-col>
    </b-row>
  </div>
</template>

<style lang="scss">
.corner {
  border-radius: 12px;
  border: 1px solid #afafaf79;
  padding: 20px;
}

.tags {
  font-size: 14px;
}

.campo-desabilitado {
  color: #b8c2cc;
}

.vs--disabled {
  .vs__selected {
    color: #b8c2cc !important;
  }
}
</style>

<script>
import { generateCode, isNumber } from '@core/utils/utils'
import { ValidationProvider } from 'vee-validate'
import vSelect from 'vue-select'

export default {
  name: 'TelaChecklist',
  components: {
    ValidationProvider,
    vSelect,
    MultiCnpjInput: () => import('@/shared/components/multi-cnpj-input/MultiCnpjInput.vue'),
    AnexoItemCheckList: () => import('@/app-modulo/comercial/cadastro-proposta/shared/components/checklist-proposta/shared/components/AnexoItemCheckList.vue'),
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    desabilitar: {
      type: Boolean,
      default: false,
    },
    propostaId: {
      type: Number,
      default: 0,
    },
    geradoProposta: {
      type: Boolean,
      default: false,
    },
    grupo: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      valueInner: {},
    }
  },
  computed: {
    state() {
      return this.valueInner.listaRespostas && this.valueInner.listaRespostas.length > 0
    },
    getCode() {
      return generateCode()
    },
  },
  watch: {
    value(value, oldValue) {
      if (value !== oldValue) {
        this.valueInner = value
      }
    },
  },
  created() {
    this.valueInner = this.value
    if (!this.valueInner.listaRespostas) {
      this.valueInner.listaRespostas = []
    }
  },
  methods: {
    isNumberValid(event) {
      isNumber(event)
    },
    mostrarErro(erro) {
      if (erro !== undefined && erro.includes('field is required')) {
        return 'Preenchimento obrigatório'
      }
      return erro
    },
    optionsDescricao(item) {
      const opcoesSemDesc = []
      for (let i = 0; i < item.servicosItems.length; i += 1) {
        opcoesSemDesc[i] = item.servicosItems[i].descricao
      }
      return opcoesSemDesc
    },
    selecionadoOutros(res) {
      const servico = this.valueInner.servicosItems.find(fin => fin.descricao === res)

      if (servico.outros) {
        // eslint-disable-next-line no-param-reassign
        this.valueInner.outrosSelecionado = true
      } else {
        // eslint-disable-next-line no-param-reassign
        this.valueInner.complementoOutros = null
        // eslint-disable-next-line no-param-reassign
        this.valueInner.outrosSelecionado = false
      }
    },
    selecionadoOutrosCaixaSelecao(resps) {
      let achouSelecaoOutros = false
      for (let i = 0; i < resps.length; i += 1) {
        const servico = this.valueInner.servicosItems.find(fin => fin.descricao === resps[i])
        if (servico.outros) {
          achouSelecaoOutros = true
        }
      }

      if (achouSelecaoOutros) {
        // eslint-disable-next-line no-param-reassign
        this.valueInner.outrosSelecionado = true
      } else {
        // eslint-disable-next-line no-param-reassign
        this.valueInner.complementoOutros = null
        // eslint-disable-next-line no-param-reassign
        this.valueInner.outrosSelecionado = false
      }
    },
    adicionarArquivoItem(file) {
      // eslint-disable-next-line no-param-reassign
      this.valueInner.nomeArquivo = file.id
      // eslint-disable-next-line no-param-reassign
      this.valueInner.arquivoAnexo = file
    },
    removerArquivoItem() {
      this.valueInner.nomeArquivo = null
      this.valueInner.arquivoAnexo = null
    },
  },
}
</script>
